import React from "react";

import TextBox from "../../../default/TextBox";
import CardButton from "../../../default/CardButton";

export default function Apply() {
  return (
    <section className="section section-main  ">
      <div className="container ">
        <TextBox
          title={applyText.title}
          text={applyText.text}
          class={applyText.class}
        />
        <article className="section-target scrollspy" id="apply">
          {/* <CardButton class={cardButtonData.class} 
                                id={cardButtonData.id} 
                                data={cardButtonData.data} /> */}
          <div className="section-con row">
            <div className={`section-con-box col s6`}>
              <h2 className="section-title ">연사사</h2>
              <div className="section-con-txt box-con-txt">
                <p className="b">
                  다양한 형태로 광고주의 크리에이티브적 고민을 해결해주는 회사
                </p>
                <p>선별된 10개 참여 기업이 크리에이티브 관련 세션 진행</p>
                <div className=" section-con-btn">
                  <a
                    // href="./pdf/2023/[MAX the Creative 4th] 연사사 신청 안내.pdf"

                    // href={`https://docs.google.com/viewer?url=${encodeURIComponent(
                    //   `${window.location.origin}/pdf/2023/[MAX the Creative 4th] 연사사 신청 안내.pdf`
                    // )}`}
                    href={`https://docs.google.com/gview?embedded=true&url=https://maxthecreative-test.netlify.app/pdf/2026/[MAX_the_Creative_5th]Call_for_Speakers.pdf`}
                    type="application/pdf"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="section-con-btn "
                  >
                    <span className="btn-style2 waves-effect waves-red font-color-red ">
                      연사사 가이드
                    </span>
                  </a>
                  <a
                    href="https://docs.google.com/forms/d/15-bCWjFkYaLMfmn8p2Uv_gPi3dzb9S1DcARC-gbP3mQ/edit"
                    // onClick={(e)=>{e.preventDefault();alert('접수가 마감되었습니다. 다음에 행사 때 많은 지원 부탁드립니다.')}}
                    target="_blank"
                    className="section-con-btn "
                  >
                    <span className="btn-style2 waves-effect waves-red font-color-red ">
                      연사사로 신청하기
                    </span>
                  </a>
                  {/* <span
                    className="btn-style2  font-color-red"
                    style={{ fontWeight: "normal" }}
                  >
                    연사사 신청이 마감되었습니다. 감사합니다.
                  </span> */}
                </div>
              </div>
            </div>
            <div className={`section-con-box col s6`}>
              <h2 className="section-title ">참석 광고주</h2>
              <div className="section-con-txt box-con-txt">
                <p className="b">
                  새로운 크리에이티브에 관심이 많고, 디지털 기반의 환경 속에서
                  자사 서비스를 효과적으로 마케팅하고자 하는 광고주
                </p>
                <p>
                  마케팅에 대해 깊은 이해와 고민을 하고 계신 300개 기업의
                  마케터로 한정 어워드 심사위원으로 참여 및 우수 참여 기업 선정
                  예정
                </p>
                <div>
                  <a
                    href={`https://docs.google.com/gview?embedded=true&url=https://maxthecreative-test.netlify.app/pdf/2026/[MAX_the_Creative_5th]Exhibitor_Attendance_Guide.pdf`}
                    type="application/pdf"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="section-con-btn "
                  >
                    <span className="btn-style2 waves-effect waves-red font-color-red ">
                      참석 광고주 가이드
                    </span>
                  </a>
                  <a
                    href="https://docs.google.com/forms/u/1/d/1g6F2DN70A7SkRLH1UTeWenPuaIN-v98VXmfEQBROjO4/edit?usp=drive_web&ouid=102169925021857500921"
                    target="_blank"
                    className="section-con-btn "
                  >
                    <span className="btn-style2 waves-effect waves-red font-color-red ">
                      참석 광고주로 신청하기
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

// DATA
const applyText = {
  class: "text-center",
  title: "ABOUT",
  text: (
    <>
      MAX The Creative는 11년간 광고업계의 대표 행사로 자리 잡은 <br /> MAX
      Summit의 스핀오프 행사로 크리에이티브 전략에 집중한 컨퍼런스입니다. <br />
      <br /> 광고 업계에서 독창적인 아이디어와 <br className="m" />
      차별화된 크리에이티브 전략으로 주목받고 있는 기업들이 <br /> 자신만의
      인사이트를 공유하고, 광고주들과의 교류를 통해 <br className="m" />
      새로운 가능성을 함께 모색합니다.
    </>
  ),
};
